import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { fetchZoom } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { fetchGeneralSettings } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { checkPDFSettings } from 'store/Course/actions'
import { present } from 'store/Group/actions'
import File from './File'

const ViewPresentation = (props) => {
  const { id } = useParams()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchGeneralSettings())
    dispatch(present())
    dispatch(fetchZoom())
  }, [])
  return (
    <div className='tl-employee-content-wrapper h-100 scrollbar'>
      {(() => {
        if (!id) {
          return null
        }

        const content = props.content.filter((item) => item.id == parseInt(id))

        if (!content.length) {
          return null
        }
        return (
          <File
            checkPDFSettings={() => dispatch(checkPDFSettings())}
            disablePdfDownload={props.disablePdfDownload}
            {...content[0].content[0]}
          />
        )
      })()}
    </div>
  )
}

export default ViewPresentation
